import pushClevertapEvent from 'clevertap/pushClevertapEvent';

export function createRole(data) {
  pushClevertapEvent('Create New Role', createAndEditDataToClevertapData(data));
}

export function editRole(data) {
  pushClevertapEvent('Edit Role', createAndEditDataToClevertapData(data));
}

export function deleteRole(data) {
  pushClevertapEvent('Delete Role', deleteDataToClevertapData(data));
}

function deleteDataToClevertapData(data) {
  const permissionAppSubMenu = [];
  const backOfficeSubMenu = [];

  for (let i = 0; i < data.permissions.length; i++) {
    const permission = data.permissions[i];
    if (permission.access === 'App') {
      permissionAppSubMenu.push(permission.sub_menu);
    } else if (permission.access === 'Back-office') {
      backOfficeSubMenu.push(getPermissionName(permission));
    }
  }

  return {
    'Role Name': data.name,
    'Access App': permissionAppSubMenu,
    'Access Back Office': backOfficeSubMenu,
  };
}

function createAndEditDataToClevertapData(data) {
  const permissionAppSubMenu = data.active_permissions_app
    ? data.active_permissions_app.map(permission => permission.sub_menu)
    : null;

  const backOfficeSubMenu = data.active_permissions_backoffice
    ? data.active_permissions_backoffice.map(permission =>
        getPermissionName(permission)
      )
    : null;

  return {
    'Role Name': data.name,
    'Access App': permissionAppSubMenu,
    'Access Back Office': backOfficeSubMenu,
  };
}

function getPermissionName(permission) {
  let name = permission.sub_menu;
  if (name !== permission.menu) {
    name = `${permission.menu} - ${name}`;
  }
  return name;
}
